import { Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom, Subject } from 'rxjs';
import { Project } from '../shared/models/project.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

const project = 'project';

const apiRoutes = {
	projects: project + '/projects',
	project: project,
	projectsTree: project + '/projects-tree',
	projectMembers: project + '/project-members',
}

@Injectable({
  providedIn: 'root'
})
export class ProjectService {

	private projectsList: Project[] = [];
	private _projects$ = new BehaviorSubject<Project[]>([]);

	private _project$ = new Subject<Project>();
  private _currentProject!: Project;

	private hideLeftSideBarSubject = new Subject<boolean>();
	hideLeftSideBar$ = this.hideLeftSideBarSubject.asObservable();

	private leftSideBarButton = new Subject<any>();
  leftSideBarEvent$ = this.leftSideBarButton.asObservable();

	loading = true;

	plan_usage = 0;

	constructor(private http: HttpClient) { }

	getProjectsTree() {
		return this.http.get<any>(environment.api + apiRoutes.projectsTree);
	}
	
	getProjectsForAssign() {
		return this.http.get<any>(environment.api + apiRoutes.projects);
	}
	
	getProjectMembers(project_id: number, params: any) {
		return this.http.get<any>(environment.api + apiRoutes.projectMembers + '/' + project_id, { params: params });
	}
	
	createProject(data: any) {
		return this.http.post<any>(environment.api + apiRoutes.project + '/create', data);
	}
	
	assignProjectMembers(project_id: number, data: any) {
		return this.http.post<any>(environment.api + apiRoutes.projectMembers + '/' + project_id, data);
	}
	
	removeProjectMember(project_id: number, data: any) {
		return this.http.delete<any>(environment.api + apiRoutes.projectMembers + '/' + project_id, { body: data});
	}

	updateProject(project_id: number, data: any) {
		return this.http.patch<any>(environment.api + apiRoutes.project + '/update/' + project_id, data);
  }

	deleteProject(project_id: number) {
		return this.http.delete<any>(environment.api + apiRoutes.project + '/remove/' + project_id);
  }

	async getProjects() {
		return firstValueFrom(this.getProjectsTree()).then(data => {
			this.plan_usage = data.usage;
			this.projectsList = data.projectTree;
			this._projects$.next(data.projectTree);
			this.loading = false;
		});
	}

	get projects$() { return this._projects$.asObservable(); }
	get project$() { return this._project$.asObservable() }

	get project() {
		return this._currentProject;
	}

	setProject(project: Project) {
    this._currentProject = project;
    this._project$.next(project);
		this.leftSideBarButton.next(false);
  }

  getProjectsList() {
    return this.projectsList;
  }

  getProject() {
    return this._currentProject;
  }

	setIsLeftSideBar(shouldHide: boolean) {
    this.hideLeftSideBarSubject.next(shouldHide);
  }

	setLeftSideBar(shouldHide: boolean) {
    this.leftSideBarButton.next(shouldHide);
  }
}
